import { BAvatar } from './avatar';
import { pluginFactory } from '../../utils/plugins';
var AvatarPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAvatar: BAvatar
  }
});
export { AvatarPlugin, BAvatar };